import { render, staticRenderFns } from "./CsEmptyState.vue?vue&type=template&id=0f87e618&"
import script from "./CsEmptyState.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsEmptyState.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports